import React from 'react';
import PropTypes from 'prop-types';

import { makeStyles } from '@material-ui/core/styles';

import Criterium from '@hydra/common/criterium/Criterium';
import CriteriumIconAndText from '@hydra/common/criterium/CriteriumIconAndText';
import SafeAnchor from '@hydra/common/components/SafeAnchor';
import Translate from '@hydra/common/components/i18n';
import Screenshot from '@hydra/common/components/Screenshot';

const useStyles = makeStyles(theme => ({
  link: {
    marginBottom: theme.spacing(1)
  },
  screenshot: {
    margin: theme.spacing(2, 0)
  }
}));

export const Amp = ({ criterium }) => {
  const classes = useStyles();
  const { data } = criterium;

  const {
    isAmpPage,
    hasAmpLink,
    isValid,
    ampLink,
    isUaSniffed,
    screenshot
  } = data;

  if (!isAmpPage && !hasAmpLink) {
    const content = <Translate content='amp_no_amp' />;
    return <Criterium criterium={criterium}>{content}</Criterium>;
  }

  if (isAmpPage) {
    const content = (
      <>
        <CriteriumIconAndText
          success={isValid}
          text={<Translate content={isValid ? 'amp_valid_amp_page' : 'amp_invalid_amp_page'} />}
        />
        {(isValid && screenshot) && <Screenshot type='phone' src={screenshot} className={classes.screenshot} />}
      </>
    );
    return <Criterium criterium={criterium}>{content}</Criterium>;
  } else if (hasAmpLink) {
    const content = (
      <>
        <CriteriumIconAndText
          success={isValid}
          text={<Translate content={isValid ? 'amp_valid_amp_link' : 'amp_invalid_amp_link'} />}
        />
        {isUaSniffed
          ? <CriteriumIconAndText success={false} text={<Translate content='amp_ua_sniffed' />} />
          : null}
        <div className={classes.link}><SafeAnchor href={ampLink} rel='nofollow noopener noreferrer' target='_blank'>{ampLink}</SafeAnchor></div>
        {(isValid && screenshot) && <Screenshot type='phone' src={screenshot} className={classes.screenshot} />}
      </>
    );
    return <Criterium criterium={criterium}>{content}</Criterium>;
  }
};

Amp.propTypes = {
  criterium: PropTypes.shape({
    data: PropTypes.shape({
      isAmpPage: PropTypes.bool,
      hasAmpLink: PropTypes.bool,
      isValid: PropTypes.bool,
      screenshot: PropTypes.string,
      ampLink: PropTypes.string
    })
  })
};

export default React.memo(Amp);
